// extracted by mini-css-extract-plugin
module.exports = {"title":"Success_title__2AyWb"};